/**
 * Custom hook for managing custom field-related logic
 */

import { ICustomFieldMap, IFormField } from '@ViewModels';
import { useMemo } from 'react';

interface UseCustomFieldManagementProps {
	customFieldManagerProps?: {
		customFieldMap?: ICustomFieldMap[];
	};
	field: IFormField<string>;
}

export const useCustomFieldManagement = ({ customFieldManagerProps, field }: UseCustomFieldManagementProps) => {
	// Check if this field has a custom field mapping
	const hasCustomField = useMemo(() => {
		if (!customFieldManagerProps?.customFieldMap) return false;
		return customFieldManagerProps.customFieldMap.some((mapping: { fieldId: string }) => mapping.fieldId === field.id);
	}, [customFieldManagerProps?.customFieldMap, field.id]);

	return {
		hasCustomField,
	};
};
